import styled from '@emotion/styled';
import { Theme } from '@material-ui/core/styles';
import { COLORS } from 'shared/constants/COLORS';
const { ERROR_BACKGROUND, LIGHT_COMPOSITE, LIGHT_BACKGROUND, DARK_BACKGROUND } = COLORS;
import { styled as coreStyled } from '@material-ui/core';
export const SelectedComp = styled('div')(({ theme }) => ({
  width: '30%',
  padding: '70px 20px 0px 30px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const CompCardContainer = coreStyled('div')(({ theme }) => ({
  position: 'relative',
  marginTop: 10,
  [theme.breakpoints.down(1042)]: {
    '& .shareable-profile-go-plus': {
      display: 'none !important',
    },
  },
}));

export const Keyframes = styled('div')<{ shake?: boolean }>(({ shake }) => ({
  '@global': {
    '@keyframes shake': {
      //change background color
      '0%, 100%': {
        color: ERROR_BACKGROUND,
        opacity: 0.8,
      },
      '10%, 90%': {
        transform: 'translate3d(-1px, 0, 0)',
      },
      '20%, 80%': {
        transform: 'translate3d(2px, 0, 0)',
      },
      '30%, 50%, 70%': {
        transform: 'translate3d(-3px, 0, 0)',
      },
      '40%, 60%': {
        transform: 'translate3d(3px, 0, 0)',
      },
    },
  },
  color: `${LIGHT_COMPOSITE} !important`,
  animation: shake ? 'shake .7s' : 'none',
  //transisiton for background color
}));

export const EightCont = styled('span')<{ shake?: boolean }>(({ shake }) => ({
  animation: shake ? 'shake .7s' : 'none',
  //transisiton for background color
}));
export const EightContFontWeight = styled('span')<{ isMaxValue?: boolean }>(({ isMaxValue }) => ({
  fontWeight: isMaxValue ? 'bold' : 'normal',
}));

export const compositeCardStyles = (theme: Theme) => ({
  switchWrapper: {
    position: 'absolute',
    height: '50px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    top: '0',
    [theme.breakpoints.up(735)]: {
      top: '-58px',
      right: '0',
    },
  },
  switchTitle: {
    fontSize: '0.875rem',
    lineHeight: '1.75',
    fontWeight: '500',
    opacity: '0.7',
    color: theme.palette.type === 'dark' ? LIGHT_BACKGROUND : DARK_BACKGROUND,
    letterSpacing: '0.02857em',
  },
  sizeCardWrapper: {
    flex: 1,
    overflowY: 'auto',
    height: '850px',
  },
});
